// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('selectTextileModel', {
//         templateUrl: 'views/components/views/selectTextileModel/selectTextileModel.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'utilityService', 'selectTextileModelService', function ($stateParams, utilityService, selectTextileModelService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let orderInternalNo = $stateParams.order_internal_no;
//             let orderLineKeyNo = $stateParams.orderline_keyno;
            
//             vm.model = {
//                 searchTextButtons: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') },
//                     { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => loadTextileModels() }
//                 ],
//                 setting: {},
//                 itemsListTextiles: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE CALLS

//             async function loadSetting() {
//                 vm.model.setting = (await selectTextileModelService.getSetting({
//                     order_internal_no: orderInternalNo,
//                     orderline_keyno: orderLineKeyNo
//                 }))[0];
//             }
            
//             async function loadTextileModels() {
//                 if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;
                
//                 return vm.model.itemsListTextiles = await selectTextileModelService.listTextileModels(vm.model.setting);
//             }

//             // #endregion LOAD PROCEDURE CALLS

//             // #region RESET BUTTON FUNCTION

//             function clear(id) {
//                 switch (id) {
//                     case 'searchtext':
//                         vm.model.setting.searchtext = '';

//                         if (vm.model.setting.searchtext === '') loadTextileModels();
//                         break;
//                     default:
//                         break;
//                 }
//             }

//             // #endregion RESET BUTTON FUNCTION

//             // #region SUBMIT SEARCH FUNCTION
            
//             vm.searchTextiles = function () {
//                 loadTextileModels();
//             }

//             // #endregion SUBMIT SEARCH FUNCTION

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'searchtext':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                         vm.model.setting.searchtext = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                         if (vm.model.setting.searchtext === '') loadTextileModels();
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 await loadSetting();
//                 loadTextileModels();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
